import * as React from 'react';
import { LoaderIcon } from 'react-hot-toast';
import LoadingBlock from './LoadingBlock';

/**
 * Two different things, told apart by whether a size was asked for.
 *
 * `<Spinner size={16} />` — an icon, inside a button or beside a label. The
 * button already says what is happening, so the icon says nothing.
 *
 * `<Spinner />` — a section is waiting for data. That used to be a circle
 * spinning silently in the middle of an empty area, thirty times over, each
 * one landing wherever its container put it. It is now the one loader the
 * whole admin uses, centred, with a line saying data is on its way, because a
 * spinner alone on a slow fetch reads as a screen that has stopped.
 *
 * Every existing call site keeps working: the ones in buttons pass a size,
 * the ones standing in for a whole section don't.
 */
const Spinner = ({ size, label, className }) => {
  if (size) {
    return <LoaderIcon style={{ width: size, height: size }} />;
  }
  return <LoadingBlock label={label} className={className} />;
};

export default Spinner;
